import { useQuery } from "@tanstack/react-query";
import type { ColumnDef } from "@tanstack/react-table";
import { Clock3 } from "lucide-react";
import { StatusPill } from "@ocs/ui";
import { adminApi } from "../api";
import { DataTable } from "../components/DataTable";
import { amount, shortAddress } from "../format";

type Settlement = {
  period_id: string; period_start_at: string; period_end_at: string; total_fee_income: string;
  distributable_amount: string; eligible_user_count: string; amount_per_user: string;
  rounding_remainder: string; batch_status: number; confirmation_status: number | null;
  settlement_payload_hash: string | null; settlement_merkle_root: string | null;
  owner_address: string | null; window_start_at: string | null; window_end_at: string | null; tx_hash: string | null;
};

const columns: ColumnDef<Settlement>[] = [
  { header: "周期", accessorKey: "period_id", cell: ({ getValue }) => <code>#{getValue<string>()}</code> },
  { header: "统计区间", cell: ({ row }) => `${new Date(row.original.period_start_at).toLocaleDateString("zh-CN")} — ${new Date(row.original.period_end_at).toLocaleDateString("zh-CN")}` },
  { header: "手续费 / 30%", cell: ({ row }) => <span className="numeric">{amount(row.original.total_fee_income)} / {amount(row.original.distributable_amount)}</span> },
  { header: "有效节点", accessorKey: "eligible_user_count" },
  { header: "每人分红", accessorKey: "amount_per_user", cell: ({ getValue }) => <b className="numeric">{amount(getValue<string>())}</b> },
  { header: "自动发放", accessorKey: "batch_status", cell: ({ getValue }) => { const value = getValue<number>(); return <StatusPill tone={value === 2 ? "success" : value === 3 ? "danger" : "warning"}>{value === 2 ? "已全部到账" : value === 3 ? "部分发放失败" : "发放处理中"}</StatusPill>; } },
  { header: "交易", accessorKey: "tx_hash", cell: ({ getValue }) => <code>{shortAddress(getValue<string | null>())}</code> }
];

export function SettlementPage() {
  const query = useQuery({ queryKey: ["settlements"], queryFn: () => adminApi<Settlement[]>("/settlements"), refetchInterval: 5000 });
  return (
    <div className="settlement-page">
      <section className="owner-boundary">
        <Clock3 />
        <div><strong>每周日 00:00–01:00 自动结算</strong><span>系统按上一周期手续费池的 30% 计算分红，并在上海时间每周日 00:00–01:00 自动发送到满足条件的用户钱包，无需用户申请提现。</span></div>
      </section>
      <DataTable data={query.data ?? []} columns={columns} emptyMessage="首个周日 00:00 自动分红后，这里会显示结算与到账进度。" />
    </div>
  );
}
